/** Human-readable remaining validity, e.g. "2 dagar kvar", "3h 20min kvar". */
export function formatRemaining(ms: number): string {
  const days = Math.floor(ms / 86_400_000);
  if (days >= 1) return `${days} ${days === 1 ? 'dag' : 'dagar'} kvar`;
  const totalMins = Math.ceil(ms / 60_000);
  const hours = Math.floor(totalMins / 60);
  const mins = totalMins % 60;
  if (hours >= 1) return mins > 0 ? `${hours}h ${mins}min kvar` : `${hours}h kvar`;
  return `${Math.max(1, mins)} min kvar`;
}
